import { useUpdateSectionMutation } from '../sectionsApi';
import { enqueueSnackbar } from 'notistack';
import { TOAST_ERROR, TOAST_SUCCESS } from '../../../utils/constants';
import i18next from 'i18next';

export const useSectionsActions = () => {
  const [updateSectionTrigger] = useUpdateSectionMutation();

  const updateSection = async ({ sectionData }) => {
    try {
      const result = await updateSectionTrigger({ sectionData }).unwrap();
      enqueueSnackbar(i18next.t('webshop.course.sectionSaved'), { variant: TOAST_SUCCESS });
      return result;
    } catch (err) {
      enqueueSnackbar(i18next.t('webshop.course.sectionSaveFailed'), { variant: TOAST_ERROR });
      throw err;
    }
  };

  return {
    updateSection,
  };
};

